import "core-js/modules/es.regexp.exec.js";
import React, { lazy, Suspense } from 'react';
import { Show, TrackingFunnelProvider, ErrorNamespaceProvider, BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
const CNXFunnel = /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxfunnel" */
/* webpackPrefetch: true */
'./CancellationFunnel'));
const cancellationRegex = /\/travel\/cancellations\//;
export function CancellationFunnel() {
  return /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
    namespace: "shell_funnel_cancellation"
  }, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
    name: "funnel_cancellation"
  }, /*#__PURE__*/React.createElement(Show, {
    when: cancellationRegex.test(window.location.href)
  }, /*#__PURE__*/React.createElement(TrackingFunnelProvider, {
    funnel: "cancellation"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(CNXFunnel, null))))));
}